class ArchiveNews {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.cta-search-btn').on('click', function(){
      $(this).siblings('.pulldown-menu').slideToggle(200);
      $(this).toggleClass('is-open');
    });
  }
}